import { instantScrollTop } from 'swag-client-common/utils/tricks';
import { changePreview, deleteLogo, changeFullScreenMode } from '../product/product.actions';
import { selectLogo, adjustLogoToImprintArea } from './logo.actions';
export const makeProductEditorDispatcher = () => dispatch => ({
  onDelete: view => {
    dispatch(deleteLogo(view));
  },
  onZoomClick: () => {
    instantScrollTop();
    dispatch(changeFullScreenMode());
  },
  onChangeView: index => {
    dispatch(changePreview(index));
  },
  onChangeImprintArea: (newImprintArea, oldImprintArea) => {
    dispatch(adjustLogoToImprintArea(newImprintArea, oldImprintArea));
  },
  onProductImageClick: () => {
    dispatch(selectLogo(null));
  }
});